<script setup>
import SelectField from '../Form/SelectField.vue';
import languages from '@/languages.js';
import { ref, watch, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAuthStore } from '@/stores/auth';
import { storeToRefs } from 'pinia';

const { t } = useI18n()
const auth = useAuthStore()
const { getUser } = storeToRefs(auth)

const nav_lang_full = navigator.language || navigator.userLanguage || 'en'
const nav_lang = nav_lang_full.split('-')[0] 

const lang = ref(localStorage.getItem('lang') || getUser?.value?.def_lang || nav_lang)

watch(lang, (val) => {
  localStorage.setItem('lang', val)
  window.location.reload()
})

const translatedLanguages = computed(() => {
  return languages.map(lang => ({
    cod: lang.cod,
    nm: t(`language.${lang.cod}`) 
  }));
});
</script>

<template>
  <div class="max-w-xl">
    <SelectField 
      :options="translatedLanguages"
      v-model="lang"
      text-attribute="nm"
      value-attribute="cod"
      class="text-sm w-full"
    />
  </div>
</template>
